<script>
import agencyApi from './../../../../api/agency';

export default {
  props: {
    defaultIsNeedApproveInterviews: {
      required: true
    }
  },

  data() {
    return {
      isNeedApproveInterviews: !!this.defaultIsNeedApproveInterviews
    };
  },

  watch: {
    isNeedApproveInterviews() {
      this.setIsNeedApproveInterviews();
    }
  },

  methods: {
    setIsNeedApproveInterviews() {
      agencyApi.setIsNeedApproveInterviews(this.isNeedApproveInterviews)
        .then(() => {
          toastr.success(`Review & approve all interviews ${this.isNeedApproveInterviews ? 'enabled' : 'disabled'}`);

          setTimeout(() => {
            location.reload();
          }, 1000);
        })
        .catch(() => {
          toastr.error('Server error. Please contact with administrator.');
        });
    }
  }
};
</script>
